import React from 'react'
import assets from '../utils/assets';
import styles from "../pages/pages.module.scss";

const AccountingList = () => {
  return (
    <img src={assets.accounting} alt="" className={`img-fluid ${styles.mHeight194}`} />
  )
}

export default AccountingList;